import i18n from "i18next";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import SharedPreferences from "../utils/SharedPreferences";
import { STORAGE_KEYS } from "../utils/Constants";

export const supportedLngs = {
  en: "English",
  ar: "Arabic (العربية)",
};

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    lng: SharedPreferences.getString(STORAGE_KEYS.LANGUAGE) ?? "en",
    fallbackLng: "en",
    debug: true,
    supportedLngs: Object.keys(supportedLngs),
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
